import { render } from "./Relations.vue?vue&type=template&id=7d775b80"
import script from "./Relations.vue?vue&type=script&lang=js"
export * from "./Relations.vue?vue&type=script&lang=js"
script.render = render

export default script